module.exports = __webpack_public_path__ + "img/wxEr.bf496708.jpg";